'use client'

import { classNames } from "../../../utils/styles/classNames.js";
import { animationBackground, animation, background, container } from "../LoadingSkeleton.css.js";
function getCommonProps({
  a11yHidden,
  onDark
}) {
  const className = classNames(
    container,
    background[onDark ? "onDark" : "onLight"],
    animation,
    animationBackground[onDark ? "onDark" : "onLight"]
  );
  return {
    "aria-busy": a11yHidden ? void 0 : "true",
    "aria-live": a11yHidden ? void 0 : "polite",
    "aria-hidden": a11yHidden ? "true" : void 0,
    className
  };
}
export {
  getCommonProps
};
